import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {MailRequest} from "../model/mail-request";

@Injectable({
  providedIn: 'root'
})
export class MailService {


  constructor(private httpClient: HttpClient) {
  }

  sendMail(mailRequest: MailRequest): Observable<any> {
    return this.httpClient.post("/api/contact", mailRequest);
  }
}
